import type { Licencie } from "@carnet/api/isia";
import type { ActivityCreateForm } from "@carnet/ui/utils/activityCreate";
import { createActivityCreateForm } from "@carnet/ui/utils/activityCreate";

// Formes des formulaires de création mutualisées avec les modales mobiles (cf. @carnet/ui).
export type ActivityFormData = ActivityCreateForm;

const forms = {
  signin: {
    Email: "",
    Civilite: undefined,
    Prenom: "",
    Nom: "",
    DateNaissance: "",
    AutoriserVisibiliteCarnet: true,
    AutoriserValidationCarnet: true,
  } as Licencie,
  register: {
    Identifiant: "",
    AutoriserVisibiliteCarnet: true,
    AutoriserValidationCarnet: true,
  } as Licencie,
  // Source unique de la forme par défaut (mutualisée avec la modale mobile) : évite la
  // divergence de valeurs initiales entre les deux tunnels.
  activity: createActivityCreateForm() as ActivityFormData,
};

export type FormType = keyof typeof forms;
export type FormRegistry = typeof forms;

export const VALID_FORM_TYPES = Object.keys(forms) as FormType[];
export const FORM_TTL_MS = 60 * 60 * 1000; // 1 hour

export const getFormDefault = <K extends FormType>(key: K): FormRegistry[K] => ({ ...forms[key] });
